import { type LocationContent } from "@/components/location-page";
import { FEES, FIRM } from "@/lib/firm";

export const CONTENT: LocationContent = {
  slug: "battery-hill",
  name: "Battery Hill",
  title: "Battery Hill conveyancing, wills and elder law",
  metaTitle: `Battery Hill Conveyancing & Wills Lawyers | ${FIRM.name}`,
  description: `Fixed-fee Battery Hill conveyancing — sales ${FEES.sale} incl. GST, purchases ${FEES.purchase}. Wills, enduring powers of attorney and estates. Call ${FIRM.phone}.`,
  lead: "Battery Hill is a settled residential pocket between Currimundi Lake and the beaches — mostly freehold houses, a good number of long-term owners, and plenty of first home buyers moving in as those homes turn over.",
  paragraphs: [
    "We act for Battery Hill buyers and sellers from Golden Beach on fixed fees. First home buyers here often qualify for the Queensland first home concession on transfer duty; we confirm eligibility and lodge the paperwork so the concession is actually claimed at settlement.",
    "On the other side of the market, many Battery Hill sales come from families selling a parent's home. That is an estate matter as much as a conveyance — the executor's authority, the grant of probate and the distribution all need to line up with the settlement date.",
    "Where a parent is moving to care rather than passing away, an enduring power of attorney is usually what makes the sale possible. Attorneys have duties and record-keeping obligations, and we take them through those before they sign anything.",
  ],
  localNotes: [
    {
      t: "First home duty concessions",
      d: "Eligibility depends on price, prior ownership and moving in within a year. We confirm it before the contract, not after duty has been assessed.",
    },
    {
      t: "Selling a parent's home",
      d: "Whether it is sold under an enduring power of attorney or by an executor changes who signs and what evidence the buyer's lawyer will require.",
    },
    {
      t: "Older houses, older approvals",
      d: "Sheds, patios and pool fencing on established blocks are frequent search issues. Pool safety certificates in particular must be sorted before settlement.",
    },
    {
      t: "Flood and overland flow",
      d: "Parts of the suburb sit near drainage lines feeding Currimundi Lake. The planning search shows the overlays that affect insurance and future extensions.",
    },
  ],
  suburbs: ["Currimundi", "Dicky Beach", "Aroona", "Little Mountain", "Caloundra", "Shelly Beach"],
  faqs: [
    {
      q: "Can I sell my parent's Battery Hill house under a power of attorney?",
      a: "Yes, if you are appointed under a valid enduring power of attorney and the financial power has commenced. You must act in the principal's best interests, keep the proceeds separate and avoid any conflict transaction — we set that up correctly and explain the record keeping.",
    },
    {
      q: "What is the first home transfer duty concession in Queensland?",
      a: "Eligible first home buyers pay reduced or no transfer duty depending on the price and whether the property is vacant land or an existing home. You must not have owned residential property before and must move in within twelve months of settlement.",
    },
    {
      q: "How long does a deceased estate take?",
      a: "A straightforward Queensland estate is commonly three to nine months: around two weeks of advertising and notice periods before applying, several weeks for the grant, then asset collection, the statutory six-month claim window and distribution.",
    },
  ],
};
